import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import { useNavigate } from "react-router-dom";
import Vehicledashboard from "./Vehicledashboard";
import Blockedvehicles from "./Blockedvehicles";
import Createnewvehicle from "./Createnewvehicle";
import FleetUtilizationHistory from "./FleetUtilizationHistory";
import VehicleDocExpiryDetails from "./VehicleDocExpiryDetails";
import Vehiclegroupsdashboard from "./Vehiclegroupsdashboard";

const Vehiclerevenuemodule = () => {
  const navigate = useNavigate();
  const navItems = routeModules?.vehiclesdashboard?.sidebar || [];
  const [activeItem, setActiveItem] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!activeItem && navItems.length > 0) {
      setActiveItem(navItems[0].label);
    }
  }, [navItems, activeItem]);

  const renderContent = () => {
    switch (activeItem) {
      case "View all Vehicles":
        return <Vehicledashboard />;
      case "Create New Vehicle":
        return <Createnewvehicle setActiveItem={setActiveItem} />;
      case "Blocked Vehicles":
        return <Blockedvehicles />;      
      // case "Fleet Utilization History":
      //   return <FleetUtilizationHistory />;
      case "Vehicle Doc Expiry Details":
        return <VehicleDocExpiryDetails />;
      case "View all Vehicle Groups":
        return <Vehiclegroupsdashboard />;
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   if (!loginTime || Date.now() - Number(loginTime) > 2 * 60 * 60 * 1000) {
  //     localStorage.clear();
  //     navigate("/");
  //   }
  // }, [navigate]);

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Layout
        module={"vehiclesdashboard"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          width: "50%",
        }}
      >
        <Toolbar />
        <Container
          maxWidth={false}
          sx={{ flexGrow: 1, minHeight: "100vh", overflow: "hidden" }}
        >
          {renderContent()}
        </Container>
      </Box>
    </Box>
  );
};

export default Vehiclerevenuemodule;
